"use client";

import { useEffect, useRef } from "react";

/**
 * A quick reply tapped on the launcher message opens the slot thread, and the thread sends the
 * label itself (through its normal outbox path, so the optimistic bubble, retry and the
 * `messageSlot` first-send field all apply). One-shot per mount.
 */
export function useInitialSlotReply(opts: {
  text: string | null | undefined;
  enabled: boolean;
  send: (text: string) => void;
  onSent?: () => void;
}): void {
  const sent = useRef(false);
  const latest = useRef(opts);
  latest.current = opts;
  const { text, enabled } = opts;
  useEffect(() => {
    if (!enabled || !text || sent.current) return;
    sent.current = true;
    latest.current.send(text);
    latest.current.onSent?.();
  }, [enabled, text]);
}
